import { ChatMessage, ChatMessagesPage, ChatTypingUpdate, UniqueVisitor } from '.';

export enum ConversationSort {
  NEWEST = 'newest',
  OLDEST = 'oldest',
}

export enum ConversationStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum ConversationFilter {
  ASSIGNED = 'assigned',
  MENTIONED = 'mentioned',
  ALL = 'all',
  UNASSIGNED = 'unassigned',
}

export interface ConversationUnreadCounts {
  agent: number;
  system: number;
  visitor: number;
  bot: number;
  ai: number;
}

export interface Conversation {
  id: number;
  assigneeId: number;
  lastAgentId: number;
  closedBy: number | null;
  dateEnded: number | null;
  dateStarted: number;
  unreadMessageCounts: ConversationUnreadCounts;
  isOpen: boolean;
  visitor: UniqueVisitor;
  lastMessage: ChatMessage | null;
  dateLastMessage: number | null;
  messages?: ChatMessagesPage;
  // Widget Local State
  typingState?: ChatTypingUpdate;
}

export type PartialConversation = Pick<
  Conversation,
  'id' | 'lastMessage' | 'dateStarted' | 'dateEnded'
>;

type ConversationStatDetail = Record<ConversationStatus, number> & {
  openUnreadMessages: number;
};

export type ConversationStats = Record<ConversationFilter, ConversationStatDetail>;

export interface ConversationsUpdate {
  data: Conversation;
  type: 'REMOVE' | 'UPDATE';
}

export interface ConversationSearchResult extends ChatMessage {
  conversation: Conversation;
}

export type RecentConversations = {
  open: Array<PartialConversation>;
  closed: Array<PartialConversation>;
};
